import styled from 'styled-components';

export const VerticalLinksContainer = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  padding: 0;
  margin: 0;
`;
